// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1EOIH","header":"Messages_header__1jVRW"};